export default [
  {
    key: 17,
    value: '激活',
    external_action: 'AD_CONVERT_TYPE_ACTIVE',
    deep_external_action: ''
  },
  {
    key: 18,
    value: '激活，深度转化，付费',
    external_action: 'AD_CONVERT_TYPE_ACTIVE',
    deep_external_action: 'AD_CONVERT_TYPE_PAY'
  },
  {
    key: 19,
    value: '激活，深度转化，次留',
    external_action: 'AD_CONVERT_TYPE_ACTIVE',
    deep_external_action: 'AD_CONVERT_TYPE_NEXT_DAY_OPEN'
  },
  {
    key: 20,
    value: '激活，深度转化，付费ROI',
    external_action: 'AD_CONVERT_TYPE_ACTIVE',
    deep_external_action: 'AD_CONVERT_TYPE_PURCHASE_ROI'
  },
  {
    key: 21,
    value: '注册',
    external_action: 'AD_CONVERT_TYPE_ACTIVE_REGISTER',
    deep_external_action: ''
  },
  {
    key: 22,
    value: '关键行为',
    external_action: 'AD_CONVERT_TYPE_GAME_ADDICTION',
    deep_external_action: ''
  },
  {
    key: 23,
    value: '付费',
    external_action: 'AD_CONVERT_TYPE_PAY',
    deep_external_action: ''
  },
  {
    key: 24,
    value: '付费，深度转化，付费ROI',
    external_action: 'AD_CONVERT_TYPE_PAY',
    deep_external_action: 'AD_CONVERT_TYPE_PURCHASE_ROI'
  },
  {
    key: 25,
    value: '付费，深度转化，付费ROI-7日',
    external_action: 'AD_CONVERT_TYPE_PAY',
    deep_external_action: 'AD_CONVERT_TYPE_PURCHASE_ROI_7D'
  },
  {
    key: 26,
    value: '完成下载',
    external_action: 'AD_CONVERT_TYPE_DOWNLOAD_START',
    deep_external_action: ''
  },
  {
    key: 27,
    value: '表单提交',
    external_action: 'AD_CONVERT_TYPE_FORM',
    deep_external_action: ''
  },
  {
    key: 28,
    value: '表单提交，深度转化，回访_信息确认',
    external_action: 'AD_CONVERT_TYPE_FORM',
    deep_external_action: 'AD_CONVERT_TYPE_CLUE_CONFIRM'
  },
  {
    key: 29,
    value: '表单提交，深度转化，回访_加为好友',
    external_action: 'AD_CONVERT_TYPE_FORM',
    deep_external_action: 'AD_CONVERT_TYPE_CLUE_INTERFLOW'
  },
  {
    key: 30,
    value: '表单提交，深度转化，回访_高潜成交',
    external_action: 'AD_CONVERT_TYPE_FORM',
    deep_external_action: 'AD_CONVERT_TYPE_CLUE_HIGH_INTENTION'
  },
  {
    key: 31,
    value: '微信_添加企业微信',
    external_action: 'AD_CONVERT_TYPE_WECHAT_WECOM_ADD',
    deep_external_action: ''
  },
  {
    key: 32,
    value: '微信内付费',
    external_action: 'AD_CONVERT_TYPE_WECHAT_PAY',
    deep_external_action: ''
  }
]

export const reserveConvertData = [
  {
    key: 33,
    value: '预约下载',
    external_action: 'AD_CONVERT_TYPE_NOTIFY_DOWNLOAD',
    deep_external_action: ''
  },
  {
    key: 34,
    value: '预约表单',
    external_action: 'AD_CONVERT_TYPE_NOTIFY_FORM',
    deep_external_action: ''
  }
]
